export default "__VITE_ASSET__DHHpQ7YM__"